import { render, staticRenderFns } from "./AdminBarrelHome.vue?vue&type=template&id=062722e2&"
import script from "./AdminBarrelHome.vue?vue&type=script&lang=js&"
export * from "./AdminBarrelHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports